import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhCN from './zh-CN.json';
import en from './en.json';
import zhTW from './zh-TW.json';
import zhVIE from './zh-VIE.json';
import { getCurrentLocale } from '@/utils/i18n';

Vue.use(VueI18n);

const messages = {
    'zh-CN': zhCN,
    'en-US': en,
    'vi-VN': zhVIE
};

const i18n = new VueI18n({
    locale: getCurrentLocale(),
    messages: messages
});

export default i18n;



// WEBPACK FOOTER //
// ./src/locales/index.js